export default {
  billOfLadingNumber: 'Bill of Lading Number',
  transportCompanyID: 'Transport company ID',
  transportCompanyName: 'Transport company name',
  payableAmount: 'Payable amount',
  payableAmountRial: 'Payable amount(Rial)',
  freightCost: 'Freight cost',
  insuranceAmount: 'Insurance amount',
  trackingReceiptTime: 'Tracking receipt time',
  year: 'Year',
  month: 'Month',
  serialNumber: 'Serial Number',
  companyId: 'Company ID',
  companyName: 'Company Name',
  trackingCode: 'Tracking Code',
  weightKilogram: 'Weight(kilogram)',
  fare: 'Fare',
  distance: 'Distance',
  originCityCode: 'Origin City Code',
  originCityName: 'Origin City Name',
  destinationCityCode: 'Destination City Code',
  destinationCityName: 'Destination City Name',
  cargoId: 'Cargo ID',
  cargoName: 'Cargo Name',
  issueDate: 'Issue Date',
  vehiclePlateNumber: 'Vehicle Plate Number',
  vehicleSerial: 'Vehicle Serial',
  vehicleNumberingPlaceCode: 'Vehicle Numbering Place Code',
  vehicleNumberingPlaceName: 'Vehicle Numbering Place Name',
  loadingCode: 'Loading Code',
  loadingType: 'Loading Type',
  packingCode: 'Packing Code',
  packingType: 'Packing Type',
  insuranceCode: 'Insurance Code (Branch)',
  insuranceNumber: 'Insurance Number',
  driverNationalId: 'First Driver National ID',
  driverName: 'First Driver Name',
  driverSmartCardCode: 'First Driver Smart Card Code',
  driverDocumentId: 'First Driver Document ID',
  secondDriverNationalId: 'Second Driver National ID',
  secondDriverName: 'Second Driver Name',
  secondDriverSmartCardCode: 'Second Driver Smart Card Code',
  secondDriverDocumentId: 'Second Driver Document ID',
  vehicleSmartCardCode: 'Vehicle Smart Card Code',
  vehicleDocumentNumber: 'Vehicle Document Number',
  senderName: 'Sender Name',
  senderNationalCode: 'Sender National Code',
  senderPostCode: 'Sender Postcode',
  senderAddress: 'Sender Address',
  receiverName: 'Receiver Name',
  receiverNationalCode: 'Receiver National Code',
  receiverPostCode: 'Receiver Postcode',
  receiverAddress: 'Receiver Address',
  registrationTime: 'Registration Time',
  trackingTime: 'Tracking Time',
  totalCostRial: 'Total Cost(rial)',
  companyCommission: 'Company Commission Percentage',
  insuranceCost: 'Insurance Cost',
  insuranceCompany: 'Insurance Company Code',
  description: 'Description',
  cargoDescription: 'Cargo Description',
  cargoValueRial: 'Cargo Value(rial)',
  trackingDate: 'Tracking Date',
  isCancelled: 'Is Cancelled',
  moveToProcessingStage: 'Move to processing stage',
  billOfLadingSuccessfullyTransferred:
    'Bill(s) of Lading Successfully Transferred',
  billOfLadingStatus: '{status} bills of lading',
  paymentQueue: 'Payment queue',
  issueDateFrom: 'Issue date from',
  issueDateTo: 'Issue date to',
  renterRegistration: 'Renter registration',
  inquiry: 'Inquiry',
  renterName: 'Renter name',
  renterShebaNumber: 'Renter sheba number',
  renterMobile: 'Renter mobile',
  renterNationalId: 'Renter national id',
  shebaNumberAndNationalIdIsMatched: 'Sheba number and national ID are matched',
  revertToReceivedStage: 'Revert to received stage',
  billOfLadingId: 'Bill of lading ID',
  payDate: 'Pay date',
  payDateFrom: 'Pay date from',
  payDateTo: 'Pay date to',
  referenceNumber: 'Reference number'
}
